import React, {useEffect, useState} from "react";
import {logo} from "../../assets/images";
import {useSettings} from "../../hooks/SettingsContext";

const Logo = () => {
	const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL; // Access the base URL
	const settings = useSettings();

	// Initialize logoSrc state
	const [logoSrc, setLogoSrc] = useState(logo);

	// Update logoSrc when settings.logo changes
	useEffect(() => {

		if (settings?.logo) {
			setLogoSrc(`${baseUrl}/${settings.logo}`);
		} else {
			setLogoSrc(logo); // Fallback to imported logo
		}
	}, [settings?.logo,baseUrl]);

	return (
		<div className='max-w-[189.63px]'>
			<img
				className="h-full mix-blend-multiply"
				src={logoSrc}
				alt="Logo"
			/>
		</div>
	);
};

export default Logo;
